// @flow
import { all } from 'redux-saga/effects'; // eslint-disable-line
import type { Saga } from 'redux-saga';

import { sagas as machineSagas } from './Machine';
import { sagas as userSagas } from './User';
import { sagas as pitSagas } from './Pit';
import { sagas as cardSagas } from './Card';

// single entry point to start all Sagas at once
export default function* rootSaga(): Saga<*> {
  // $FlowFixMe
  yield all([machineSagas(), userSagas(), pitSagas(), cardSagas()]);
}
